import { render, staticRenderFns } from "./order-report.vue?vue&type=template&id=1ab96f55&scoped=true"
import script from "./order-report.vue?vue&type=script&lang=js"
export * from "./order-report.vue?vue&type=script&lang=js"
import style0 from "./order-report.vue?vue&type=style&index=0&id=1ab96f55&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab96f55",
  null
  
)

export default component.exports